import { render } from "./MarketingSelect.vue?vue&type=template&id=4f7d8e1a&scoped=true"
import script from "./MarketingSelect.vue?vue&type=script&lang=js"
export * from "./MarketingSelect.vue?vue&type=script&lang=js"

import "./MarketingSelect.vue?vue&type=style&index=0&id=4f7d8e1a&lang=scss&scoped=true"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7d8e1a"]])

export default __exports__